import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { PipelinedetailsService } from '../../service/pipelinedetails.service';
import { PipelinedetailsFacade } from '../../states/+pipelinedetails/pipelinedetails.facade';
import { PipelineDetailsDto, UomDto, LicenceStatusDto, AssetStatusDto, PigibilityDto, PipelineAssetLocationDto, DeliveryTypeDto, NetworkDto, IPStatusDto, PipelineGradeDto, AccountableFunctionLink2Dto, PipelineAssetLink2Dto, PipelineSectionDto, AccountableFunctionDto, FunctionDto, LandTitleDto, SubSubGroupDto, CategoryDto, OpllPtsHistoryDto } from '@cradua/data';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { AcquisitionFacade } from "libs/acquisition/src/lib/state/+acquisition/acquisition.facade";
import { fadeInAnimation } from 'libs/shared/src/lib/_animations/fade-in.animation';
import { PipelineGenericFacade } from "../../states/+pipeline-generic/pipeline-generic.facade";

@Component({
  selector: 'cradua-pipelinedetails-container',
  templateUrl: './pipelinedetails-container.component.html',
  styleUrls: ['./pipelinedetails-container.component.scss'],
  animations: [fadeInAnimation],
})
export class PipelinedetailsContainerComponent implements OnInit {

  isLoadingPipelinedetails$: Observable<any>;
  isLoadingAssetstatuss$: Observable<any>;
  isLoadingPigibilitys$: Observable<any>;
  isLoadingAssetlocations$: Observable<any>;
  isLoadingDeliverytypes$: Observable<any>;
  isLoadingUomes$: Observable<any>;
  isLoadingLicencestatuss$: Observable<any>;
  isLoadingNetworks$: Observable<any>;
  isLoadingIpstatuss$: Observable<any>;
  isLoadingPipelinegrades$: Observable<any>;
  isLoadingAcountablefunctionlink2s$: Observable<any>;
  isLoadingPipelinesections$: Observable<any>;
  isLoadingPipelineassetlink2s$: Observable<any>;
  isLoadingAccountablefunctions$: Observable<any>;
  isLoadingFunctions$: Observable<any>;
  isLoadingPipelineassets$: Observable<any>;
  isLoadingLandTitle$: Observable<any>;
  isLoadingOpllptshistorys$: Observable<any>;

  assetstatuss$: Observable<AssetStatusDto[]>;
  pigibilitys$: Observable<PigibilityDto[]>;
  assetlocations$: Observable<PipelineAssetLocationDto[]>;
  deliverytypes$: Observable<DeliveryTypeDto[]>;
  uomes$: Observable<UomDto[]>;
  pipelineDetail$: Observable<PipelineDetailsDto[]>;
  licencestatuss$: Observable<LicenceStatusDto[]>;
  networks$: Observable<NetworkDto[]>;
  ipstatuss$: Observable<IPStatusDto[]>;
  pipelinegrades$: Observable<PipelineGradeDto[]>;
  acountablefunctionlink2s$: Observable<AccountableFunctionLink2Dto[]>;
  pipelineassetlink2s$: Observable<PipelineAssetLink2Dto[]>;
  pipelinesections$: Observable<PipelineSectionDto[]>;
  accountablefunctions$: Observable<AccountableFunctionDto[]>;
  functions$: Observable<FunctionDto[]>;
  pipelineassets$: Observable<LandTitleDto[]>;
  subsubgroups$: Observable<SubSubGroupDto[]>;
  categorys$: Observable<CategoryDto[]>;
  opllptshistorys$: Observable<OpllPtsHistoryDto[]>;
  landTitle$: Observable<LandTitleDto[]>;
  loggedInUser = JSON.parse(localStorage.getItem("LoggedInUser"));
  task = "list";
  selectedPipelineDetails: PipelineDetailsDto;


  constructor(
    public dialog: MatDialog, private pipelineFacade: PipelinedetailsFacade,private gatewwayFacade: GatewayFacade,
    private router: Router, private notificationService: NotificationService,
    private pipelineGenericFacade: PipelineGenericFacade
    ) {
      
   }

  ngOnInit() {
    this.isLoadingAssetstatuss$ = this.gatewwayFacade.isLoadingGateway("AssetStatus");
    this.isLoadingPigibilitys$ = this.gatewwayFacade.isLoadingGateway("Pigibility");
    this.isLoadingAssetlocations$ = this.gatewwayFacade.isLoadingGateway("PipelineAssetLocation");
    this.isLoadingDeliverytypes$ = this.gatewwayFacade.isLoadingGateway("DeliveryType");
    this.isLoadingUomes$ = this.gatewwayFacade.isLoadingGateway("Uom");
    this.isLoadingLicencestatuss$ = this.gatewwayFacade.isLoadingGateway("LicenceStatus");
    this.isLoadingNetworks$ = this.gatewwayFacade.isLoadingGateway("Network");
    this.isLoadingIpstatuss$ = this.gatewwayFacade.isLoadingGateway("IPStatus");
    this.isLoadingPipelinegrades$ = this.gatewwayFacade.isLoadingGateway("PipelineGrade");
    this.isLoadingAccountablefunctions$ = this.gatewwayFacade.isLoadingGateway("AccountableFunction");
    this.isLoadingFunctions$ = this.gatewwayFacade.isLoadingGateway("Function");
    // this.isLoadingOpllptshistorys$ = this.gatewwayFacade.isLoadingGateway("OpllPtsHistory");

    
    this.assetstatuss$ = this.gatewwayFacade.loadGateway("AssetStatus");
    this.pigibilitys$ = this.gatewwayFacade.loadGateway("Pigibility");
    this.assetlocations$ = this.gatewwayFacade.loadGateway("PipelineAssetLocation");
    this.deliverytypes$ = this.gatewwayFacade.loadGateway("DeliveryType");
    this.licencestatuss$ = this.gatewwayFacade.loadGateway("LicenceStatus");
    this.uomes$ = this.gatewwayFacade.loadGateway("Uom");
    this.networks$ = this.gatewwayFacade.loadGateway("Network");
    this.pipelinegrades$ = this.gatewwayFacade.loadGateway("PipelineGrade");
    this.ipstatuss$ = this.gatewwayFacade.loadGateway("IPStatus");
    this.pipelinesections$ = this.pipelineGenericFacade.loadGatewayById('PipelineSection');
    this.acountablefunctionlink2s$ = this.pipelineGenericFacade.loadGatewayById("AccountableFunctionLink2");
    this.pipelineassetlink2s$ = this.pipelineGenericFacade.loadGatewayById("PipelineAssetLink2");
    this.pipelineDetail$ = this.pipelineFacade.loadRegister$;
    this.landTitle$ = this.pipelineGenericFacade.loadGatewayWithoutId('LandTitle');
    this.isLoadingLandTitle$ = this.pipelineGenericFacade.isLoadingPipelineGenericWithoutId('LandTitle');
    // this.gatewwayFacade.loadGateway("DeliveryType").subscribe(a => {
    //   console.log('a', a);
    // })
    this.functions$ = this.gatewwayFacade.loadGateway("Function");
    this.accountablefunctions$ = this.gatewwayFacade.loadGateway("AccountableFunction");
    this.subsubgroups$ = this.gatewwayFacade.loadGateway("SubSubGroup");
    this.categorys$ = this.gatewwayFacade.loadGateway("Category");
    this.opllptshistorys$ = this.pipelineGenericFacade.loadGatewayById("OpllPtsHistory");
    this.pipelineGenericFacade.loadGatewayById("OpllPtsHistory").subscribe(a => {
      console.log('a', a);
    })
  }

  onSearch(value) {
    console.log('search ', value)
    let query = {
      name: value,
    };
    this.isLoadingPipelinedetails$ = this.pipelineFacade.isLoadingPipelinedetails(query);
  }
  
  onGetAll(value) {
    console.log('checked ', value)
      let query = {
        name: value,
      };
    this.isLoadingPipelinedetails$ = this.pipelineFacade.isLoadingPipelinedetails(query);
  }

  onTask(task: string) {
    console.log('task ', task);
    this.task = task;
    this.selectedPipelineDetails = null;
    this.pipelineDetail$ = this.pipelineFacade.clearPipelinedetails;
    this.pipelinesections$ = this.pipelineGenericFacade.loadGatewayClear('PipelineSection');
    this.acountablefunctionlink2s$ = this.pipelineGenericFacade.loadGatewayClear('AccountableFunctionLink2');
    this.pipelineassetlink2s$ = this.pipelineGenericFacade.loadGatewayClear('PipelineAssetLink2');
    this.opllptshistorys$ = this.pipelineGenericFacade.loadGatewayClear('OpllPtsHistory');
  }

  onEmitView(value: PipelineDetailsDto) {
    if(value != null) {
      this.isLoadingPipelinedetails$ = this.pipelineFacade.isLoadingPipelinedetailsById(value.id);
      this.isLoadingPipelinesections$ = this.pipelineGenericFacade.isLoadingPipelineGenericById('PipelineSection', value.id);
      this.isLoadingPipelineassetlink2s$ = this.pipelineGenericFacade.isLoadingPipelineGenericById('PipelineAssetLink2', value.id);
      this.isLoadingAcountablefunctionlink2s$ = this.pipelineGenericFacade.isLoadingPipelineGenericById('AccountableFunctionLink2', value.id);
      this.isLoadingOpllptshistorys$ = this.pipelineGenericFacade.isLoadingPipelineGenericById('OpllPtsHistory', value.id);
    }
    this.task = 'create';
  }

  onBack() {
    this.task = 'create';
  }

  onNext(value) {
    // this.task = 'section';
    // this.selectedPipelineDetails = value;
  }

  onFxtDelete(deletedValue) {
    this.pipelineGenericFacade.remove("AccountableFunctionLink2", deletedValue);
    this.notificationService.success('Deleted Successfully');
  }

  onAssetDelete(deletedValue) {
    this.pipelineGenericFacade.remove("PipelineAssetLink2", deletedValue);
    this.notificationService.success('Deleted Successfully');
  }

  onAssetSubmit(formData) {
    // if(formData.id === null) {
    //   formData['id'] = undefined;
    //   }
    //    const newValue = [];
    //    newValue.push(formData);
    this.pipelineGenericFacade.add('PipelineAssetLink2', formData);
    this.notificationService.success('Saved Successfully');
  }

  onFxtSubmit(formData) {
    this.pipelineGenericFacade.add('AccountableFunctionLink2', formData);
    this.notificationService.success('Saved Successfully');
  }

  onSectionDelete(deletedValue) {
    console.log('value to delete: ', deletedValue);

    this.pipelineGenericFacade.remove("PipelineSection", deletedValue);
    this.notificationService.success('Deleted Successfully');
  }

  onSectionSubmit(formData) {
    if(formData.id === null) {
      formData['id'] = undefined;
      }
       const newConstruct = [];
      if(formData.id != null) {
        newConstruct.push(formData);
        this.pipelineGenericFacade.update('PipelineSection', newConstruct, ['id']);
        this.notificationService.success('Updated Successfully');
      } else {
        const {id, ...newValue} = formData;
        newConstruct.push(formData);
        console.log("secetions all: ", newConstruct);
        this.pipelineGenericFacade.add('PipelineSection', newConstruct);
        this.notificationService.success('Saved Successfully');
      }
  }

  onSubmit(formData: any) {
    const listdata = [];
    if(formData.id != null) {
      this.isLoadingPipelinedetails$ = this.pipelineFacade.updatePipelinedetails(formData);
    } else {
      const {id, ...newFormData} = formData;
      this.isLoadingPipelinedetails$ = this.pipelineFacade.addPipelinedetails(newFormData);
    }
        let data  = {
          Type: "",
          OpllPtsNumber: "",
          EntryDate: "",
          AutoSerialId: formData.id,
          id: null
        };
        let data1  = {
          Type: "",
          OpllPtsNumber: "",
          EntryDate: "",
          AutoSerialId: formData.id,
          id: null
        };
        
        if(formData.OPLLNumber) {
          data.Type = "OPLL",
          data.OpllPtsNumber = formData.OPLLNumber,
          data.EntryDate = new Date().toString()
        }
  
        if(formData.PTSNumber) {
          data1.Type = "PTS",
          data1.OpllPtsNumber = formData.PTSNumber,
          data1.EntryDate = new Date().toString()
        }

        listdata.push(data,data1);
        
        let allUpdates = [];
        let addAllHistory = [];
        
        // loop through the form data to check for update and create
        for (let i = 0; i < listdata.length; i++) {
          
          this.opllptshistorys$.subscribe(data => {
            const ptsopllnumber = data.find(a => a.OpllPtsNumber === listdata[i].OpllPtsNumber)
            if (!ptsopllnumber) {
              delete listdata[i].id;
              addAllHistory.push(listdata[i]);
            }
          });

          
        }
        if (addAllHistory) {
          this.pipelineGenericFacade.add('OpllPtsHistory', addAllHistory);
          this.notificationService.success('Saved Successfully');

        }
        

   

    
  }
}
